module.exports = __webpack_public_path__ + "img/jingyingbang-zl.3fa74d34.png";